/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsDeliveryGetStationConfigConfigQueryResponse, FragmentsDeliveryGetStationConfigConfigPathParams, FragmentsDeliveryGetStationConfigConfig401, FragmentsDeliveryGetStationConfigConfig403 } from "../models/FragmentsDeliveryGetStationConfigConfig";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { fragmentsDeliveryGetStationConfigConfig } from "../axios/fragmentsDeliveryGetStationConfigConfig";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const fragmentsDeliveryGetStationConfigConfigQueryKey = (stationId: FragmentsDeliveryGetStationConfigConfigPathParams["stationId"]) => ["api-v2", { url: '/fragments-delivery/v1/station-config/:stationId', params: {stationId:stationId} }] as const

export type FragmentsDeliveryGetStationConfigConfigQueryKey = ReturnType<typeof fragmentsDeliveryGetStationConfigConfigQueryKey>

export function fragmentsDeliveryGetStationConfigConfigQueryOptions(stationId: FragmentsDeliveryGetStationConfigConfigPathParams["stationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = fragmentsDeliveryGetStationConfigConfigQueryKey(stationId)
        return queryOptions<FragmentsDeliveryGetStationConfigConfigQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetStationConfigConfig401 | FragmentsDeliveryGetStationConfigConfig403>, FragmentsDeliveryGetStationConfigConfigQueryResponse, typeof queryKey>({
         enabled: !!(stationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return fragmentsDeliveryGetStationConfigConfig(stationId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get Station config (client access)
 * {@link /fragments-delivery/v1/station-config/:stationId}
 */
export function useFragmentsDeliveryGetStationConfigConfig<TData = FragmentsDeliveryGetStationConfigConfigQueryResponse, TQueryData = FragmentsDeliveryGetStationConfigConfigQueryResponse, TQueryKey extends QueryKey = FragmentsDeliveryGetStationConfigConfigQueryKey>(stationId: FragmentsDeliveryGetStationConfigConfigPathParams["stationId"], options: 
{
  query?: Partial<QueryObserverOptions<FragmentsDeliveryGetStationConfigConfigQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetStationConfigConfig401 | FragmentsDeliveryGetStationConfigConfig403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? fragmentsDeliveryGetStationConfigConfigQueryKey(stationId)
         

         const query = useQuery({
          ...fragmentsDeliveryGetStationConfigConfigQueryOptions(stationId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FragmentsDeliveryGetStationConfigConfig401 | FragmentsDeliveryGetStationConfigConfig403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}